module.exports = __webpack_public_path__ + "static/media/chill-spins-1024x458-dark.c507dcef.png";